/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_WhenInputs */

const cs_col_when = /** @type {(inputs: Col_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kdy`)
};

const en_col_when = /** @type {(inputs: Col_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When`)
};

/**
* | output |
* | --- |
* | "When" |
*
* @param {Col_WhenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_when = /** @type {((inputs?: Col_WhenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_WhenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_when(inputs)
	return cs_col_when(inputs)
});